<div *ngIf="data">
	<app-client-side-data-table
		[id]="'workspaces-table-id'"
		[selectFieldName]="'id'"
		[data]="data"
		[columns]="columns"
		[sort]="sort"
		[eventService]="workspacesListEventsService"
		[refreshIt]="refreshDataTable"
	></app-client-side-data-table>
</div>
